import { Icon } from 'shared/iconpack'

import { palette } from 'shared/config/styles/palette'

interface Props {
  isWithFilters: boolean
}
const EmptyTable = ({ isWithFilters }: Props) => {
  return (
    <div className="h-full !flex flex-col items-center justify-center p-[16px] gap-[10px]">
      <Icon
        name="emptyTable"
        size={52}
        color={palette.light_gray_10}
      />
      <strong className="leading-[24px] text-[16px] text-dark">
        {isWithFilters ? 'Результаты поиска отсутствуют' : 'Здесь пока пусто'}
      </strong>
    </div>
  )
}

export default EmptyTable
